import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-divider",
  "use": "icon-divider-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-divider\"><defs><style type=\"text/css\"></style></defs><path d=\"M64 480h128v64H64z m256 0h128v64H320z m256 0h128v64H576z m256 0h128v64H832zM0 640v384h64V704h896v320h64V640z m0-256h1024V0h-64v320H64V0H0z\" p-id=\"10577\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/divider.svg
// module id = zI1Y
// module chunks = 11